import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getUserTypes} from 'src/openapi/admin/apis/GetUserTypesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectUserTypes} from './services/dictionary-slice';

export const useUserTypes = () => {
    const apiDispatch = useAppDispatch();
    const userTypes = useSelector(selectUserTypes);

    const loadUserTypes = useCallback(() => {
        if (!userTypes.length) {
            apiDispatch(getUserTypes());
        }
    }, [userTypes.length, apiDispatch]);

    const getUserTypeByCode = useCallback((typeCode: string) => {
        return userTypes.find(type => type.code === typeCode);
    }, [userTypes]);

    return {userTypes, loadUserTypes, getUserTypeByCode};
};
